import{useRoutingContext as t}from"../context/RoutingContext.js";function o(){return t().format}export{o as useFormatter};
//# sourceMappingURL=use-formatter.js.map
